module.exports = __webpack_public_path__ + "static/media/4.eb1e5512.JPG";